import { render } from "./SemesterInfoPage.vue?vue&type=template&id=59ca2b54"
import script from "./SemesterInfoPage.vue?vue&type=script&lang=js"
export * from "./SemesterInfoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__